import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=3480bec7&"
import script from "./MoneyInput.vue?vue&type=script&lang=js&"
export * from "./MoneyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports